"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mimetypes = exports.WebcamCapability = exports.RandomCapability = void 0;
var RandomCapability_1 = require("./RandomCapability");
Object.defineProperty(exports, "RandomCapability", { enumerable: true, get: function () { return RandomCapability_1.RandomCapability; } });
var WebcamCapability_1 = require("./WebcamCapability");
Object.defineProperty(exports, "WebcamCapability", { enumerable: true, get: function () { return WebcamCapability_1.WebcamCapability; } });
/**
 * Mimetypes for the model formats known by rune.
 */
exports.mimetypes = {
    tflite: "application/tflite-model",
    tensorflow: "application/tf-model",
    tfjs: "application/tfjs-model",
    onnx: "application/onnx-model",
};
